export class KioskHealthStatisticsModel {
    public totalCount: number;
    public totalOnlineCount: number;
}
